import { render, staticRenderFns } from "./sum_ang.vue?vue&type=template&id=52bff542&"
import script from "./sum_ang.vue?vue&type=script&lang=js&"
export * from "./sum_ang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports